document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[action="/account"]');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const phoneInput = form.querySelector('input[name="phone"]');
    const phone = phoneInput?.value.trim();
    if (!phone) return form.submit();

    try {
      const resp = await fetch('http://localhost:3000/check-phone?phone=' + encodeURIComponent(phone));
      const json = await resp.json();
      if (json.exists) {
        alert('Este teléfono ya está registrado. Usa "¿Olvidaste tu contraseña?"');
        return;
      }
      form.submit();
    } catch (err) {
      console.error(err);
      form.submit();
    }
  });
});
